export const FEAT_FORMS: any[] = [
    {
        "columns" : [ {
            "name" : "productFeatureCategoryId",
            "title" : "ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "update",
            "title" : "Update"
        } ],
        "formName" : "ListProductFeatureCategories",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "ID",
            "type" : "HYPERLINK",
            "target" : "EditFeatureCategoryFeatures",
            "name" : "productFeatureCategoryId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureCategoryId"
            } ],
            "style" : "",
            "id" : "ListProductFeature_productFeatureCategoryId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formLocation":"component://kwikstore/widget/FeatureForms.xml",
                "formName":"EditFeatureCategoryFeatures",
              },
              "appContext":"catalog",
              "event":"list"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ListProductFeature_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListProductFeature",
            "tabindex" : "",
            "name" : "update",
            "className" : "",
            "id" : "ListProductFeature_update",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "UpdateFeatureCategory"
    },
    {
        "columns" : [ {
            "name" : "productFeatureId",
            "title" : "ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "productFeatureTypeId",
            "title" : "Feature Type"
        }, {
            "name" : "productFeatureCategoryId",
            "title" : "Feature Category"
        }, {
            "name" : "uomId",
            "title" : "Unit of Measure ID"
        }, {
            "name" : "numberSpecified",
            "title" : "Quantity"
        }, {
            "name" : "defaultAmount",
            "title" : "Amount"
        }, {
            "name" : "defaultSequenceNum",
            "title" : "ID Seq Num"
        }, {
            "name" : "idCode",
            "title" : "ID Code"
        }, {
            "name" : "abbrev",
            "title" : "Abbrev"
        } ],
        "formName" : "EditFeatureCategoryFeatures",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "idFieldName":"productFeatureId",
        "type" : "multi",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "_rowSubmit",
            "action" : "",
            "id" : "EditFeatureCategoryFeatures__rowSubmit",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "ID",
            "type" : "HYPERLINK",
            "target" : "EditProductFeature",
            "name" : "productFeatureId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productFeatureId"
            } ],
            "style" : "",
            "id" : "EditFeatureCategoryFeatures_productFeatureId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formLocation":"component://kwikstore/widget/FeatureForms.xml",
                "formName":"EditProductFeature",
            },
            "event":"edit"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFeatureCategoryFeatures",
            "options" : [ {
            "description" : "Accessory",
            "key" : "ACCESSORY"
            }, {
            "description" : "Amount",
            "key" : "AMOUNT"
            }, {
            "description" : "Artist",
            "key" : "ARTIST"
            }, {
            "description" : "Billing Feature",
            "key" : "BILLING_FEATURE"
            }, {
            "description" : "Brand",
            "key" : "BRAND"
            }, {
            "description" : "Care",
            "key" : "CARE"
            }, {
            "description" : "Color",
            "key" : "COLOR"
            }, {
            "description" : "Dimension",
            "key" : "DIMENSION"
            }, {
            "description" : "Equipment Class",
            "key" : "EQUIP_CLASS"
            }, {
            "description" : "Fabric",
            "key" : "FABRIC"
            }, {
            "description" : "Genre",
            "key" : "GENRE"
            }, {
            "description" : "Gift Wrap",
            "key" : "GIFT_WRAP"
            }, {
            "description" : "Hardware Feature",
            "key" : "HARDWARE_FEATURE"
            }, {
            "description" : "Hazmat",
            "key" : "HAZMAT"
            }, {
            "description" : "License",
            "key" : "LICENSE"
            }, {
            "description" : "Model Year",
            "key" : "MODEL_YEAR"
            }, {
            "description" : "Net Weight",
            "key" : "NET_WEIGHT"
            }, {
            "description" : "Origin",
            "key" : "ORIGIN"
            }, {
            "description" : "Other Feature",
            "key" : "OTHER_FEATURE"
            }, {
            "description" : "Product Quality",
            "key" : "PRODUCT_QUALITY"
            }, {
            "description" : "Size",
            "key" : "SIZE"
            }, {
            "description" : "Software Feature",
            "key" : "SOFTWARE_FEATURE"
            }, {
            "description" : "Style",
            "key" : "STYLE"
            }, {
            "description" : "Symptom",
            "key" : "SYMPTOM"
            }, {
            "description" : "Topic",
            "key" : "TOPIC"
            }, {
            "description" : "Type",
            "key" : "TYPE"
            }, {
            "description" : "Warranty",
            "key" : "WARRANTY"
            }, {
            "description" : "Year Made",
            "key" : "YEAR_MADE"
            } ],
            "disabled" : "false",
            "id" : "EditFeatureCategoryFeatures_productFeatureTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Category",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFeatureCategoryFeatures",
            "options" : [ {
            "description" : "Account Features",
            "key" : "2100"
            }, {
            "description" : "Equipment Class Features",
            "key" : "1002"
            }, {
            "description" : "Gift Card Features",
            "key" : "2000"
            }, {
            "description" : "Hazmat Features",
            "key" : "1000"
            }, {
            "description" : "Image",
            "key" : "IMAGE"
            }, {
            "description" : "License Features",
            "key" : "8000"
            }, {
            "description" : "Model Year Features",
            "key" : "1001"
            }, {
            "description" : "Scanning Type",
            "key" : "SCAN_TYPE"
            }, {
            "description" : "Taste",
            "key" : "3000"
            }, {
            "description" : "Text",
            "key" : "TEXT"
            }, {
            "description" : "Widget Features",
            "key" : "9000"
            } ],
            "disabled" : "false",
            "id" : "EditFeatureCategoryFeatures_productFeatureCategoryId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureCategoryId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Unit of Measure ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFeatureCategoryFeatures",
            "options" : [ {
            "description" : "Square Yard",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Rod",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Millimeter",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Mile",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Meter",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Kilometer",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Inch",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Foot",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Square Centimeter",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Hectare",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Are",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Acre",
            "key" : "AREA_MEASURE"
            }, {
            "description" : "Terabit-per-second of Data",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Gigabit-per-second of Data",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Megabit-per-second of Data",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Kilobit-per-second of Data",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Bit-per-second of Data",
            "key" : "DATASPD_MEASURE"
            }, {
            "description" : "Petabyte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Terabyte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Gigabyte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Megabyte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Kilobyte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Byte of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Petabit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Terabit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Gigabit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Megabit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Kilobit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Bit of Data",
            "key" : "DATA_MEASURE"
            }, {
            "description" : "Yard",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Rod",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Pica (type size)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Point (type size)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Mil (Milli-inch)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Millimeter",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Mile (nautical/sea)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Mile (statute/land)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Micrometer (Micron)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Meter",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Link (Ramden\\'s)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Link (Gunter\\'s)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "League",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Kilometer",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Inch",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Hand (horse\\'s height)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Furlong",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Foot",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Fathom",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Dekameter",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Decimeter",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Chain (Ramden\\'s/engineer\\'s)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Chain (Gunter\\'s/surveyor\\'s)",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Centimeter",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Cable",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Angstrom",
            "key" : "LENGTH_MEASURE"
            }, {
            "description" : "Package",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Box",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Per Person",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Each",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Mole - Substance (molecule)",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Candela - Luminosity (intensity of light)",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Amphere - Electric current",
            "key" : "OTHER_MEASURE"
            }, {
            "description" : "Cubic yard",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Cubic meter",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Cubic inch",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Cubic foot",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Cubic centimeter",
            "key" : "VOLUME_DRY_MEASURE"
            }, {
            "description" : "Teaspoon",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Tablespoon",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Quart",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Pint (US)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Pint (UK)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Ounce, fluid (US)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Ounce, fluid (UK)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Milliliter",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Liter",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Hectoliter",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Cubic meter (liquid)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Gallon (US)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Gallon (UK)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Gill (1/4 UK pint)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Dram (US)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Cup",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Barrel (US)",
            "key" : "VOLUME_LIQ_MEASURE"
            }, {
            "description" : "Ton (short or US)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Ton (metric)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Stone",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Pennyweight",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Milligram",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Kilogram",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Gram",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Grain",
            "key" : "WEIGHT_MEASURE"
            }, {
            "description" : "Dram (avdp)",
            "key" : "WEIGHT_MEASURE"
            } ],
            "disabled" : "false",
            "id" : "EditFeatureCategoryFeatures_uomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "uomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "numberSpecified",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_numberSpecified",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Amount",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultAmount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_defaultAmount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Seq Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultSequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_defaultSequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "ID Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "idCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_idCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Abbrev",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "abbrev",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFeatureCategoryFeatures_abbrev",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        } ],
        "target" : "UpdateProductFeatureInCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureCategoryId", "productFeatureCategoryId", "productFeatureCategoryId", "parentCategoryId", "description", "parentCategory", "submitButton" ]
        } ],
        "formName" : "EditProductFeatureCategory",
        "altTarget" : [ {
            "useWhen" : "productFeatureCategory==null",
            "targetExdr" : {
            "chars" : "createProductFeatureCategory",
            "hint" : 20,
            "empty" : false,
            "original" : "createProductFeatureCategory"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Parent Category ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "parentCategoryId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductFeatureCategory_parentCategoryId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "disabled" : false,
            "id" : "EditProductFeatureCategory_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductFeatureCategory",
            "options" : [ {
            "description" : "Image",
            "key" : "Image"
            }, {
            "description" : "Text",
            "key" : "Text"
            }, {
            "description" : "Scanning Type",
            "key" : "Scanning Type"
            }, {
            "description" : "License Features",
            "key" : "License Features"
            }, {
            "description" : "Widget Features",
            "key" : "Widget Features"
            }, {
            "description" : "Gift Card Features",
            "key" : "Gift Card Features"
            }, {
            "description" : "Hazmat Features",
            "key" : "Hazmat Features"
            }, {
            "description" : "Model Year Features",
            "key" : "Model Year Features"
            }, {
            "description" : "Equipment Class Features",
            "key" : "Equipment Class Features"
            }, {
            "description" : "Taste",
            "key" : "Taste"
            }, {
            "description" : "Account Features",
            "key" : "Account Features"
            }, {
            "description" : "Number of Administrator Accounts",
            "key" : "Number of Administrator Accounts"
            }, {
            "description" : "Number of Product Catalogs",
            "key" : "Number of Product Catalogs"
            }, {
            "description" : "Number of Stock Keeping Units",
            "key" : "Number of Stock Keeping Units"
            }, {
            "description" : "Cool Features",
            "key" : "Cool Features"
            } ],
            "disabled" : "false",
            "id" : "EditProductFeatureCategory_parentCategory",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "parentCategory",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductFeatureCategory",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProductFeatureCategory_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductFeatureCategory"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "parentFeatureCategoryId", "description", "removeChildFeatureCategory" ]
        } ],
        "columns" : [ {
            "name" : "productFeatureCategoryId",
            "title" : "Product Feature Category ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "removeChildFeatureCategory",
            "title" : ""
        } ],
        "formName" : "ChildProductFeatureCategories",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "parentFeatureCategoryId",
            "action" : "",
            "id" : "ChildProductFeatureCategories_parentFeatureCategoryId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productFeatureCategoryId",
            "description" : "",
            "style" : "",
            "id" : "ChildProductFeatureCategories_productFeatureCategoryId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ChildProductFeatureCategories_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "removeChildFeatureCategory",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "productFeatureCategoryId"
            }, {
            "name" : "parentFeatureCategoryId"
            } ],
            "id" : "ChildProductFeatureCategories_removeChildFeatureCategory",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeChildFeatureCategory"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productFeatureCategoryId", "submitButton" ]
        } ],
        "formName" : "AddChildProductFeatureCategory",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FeatureForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "parentFeatureCategoryId",
            "action" : "",
            "id" : "AddChildProductFeatureCategory_parentFeatureCategoryId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Feature Category",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "_NA_",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddChildProductFeatureCategory",
            "options" : [ {
            "description" : "Account Features",
            "key" : "2100"
            }, {
            "description" : "Cool Features",
            "key" : "10000"
            }, {
            "description" : "Equipment Class Features",
            "key" : "1002"
            }, {
            "description" : "Gift Card Features",
            "key" : "2000"
            }, {
            "description" : "Hazmat Features",
            "key" : "1000"
            }, {
            "description" : "Image",
            "key" : "IMAGE"
            }, {
            "description" : "License Features",
            "key" : "8000"
            }, {
            "description" : "Model Year Features",
            "key" : "1001"
            }, {
            "description" : "Number of Administrator Accounts",
            "key" : "NUMBER_ADMINS"
            }, {
            "description" : "Number of Product Catalogs",
            "key" : "NUMBER_CATS"
            }, {
            "description" : "Number of Stock Keeping Units",
            "key" : "NUMBER_SKUS"
            }, {
            "description" : "Scanning Type",
            "key" : "SCAN_TYPE"
            }, {
            "description" : "Taste",
            "key" : "3000"
            }, {
            "description" : "Text",
            "key" : "TEXT"
            }, {
            "description" : "Widget Features",
            "key" : "9000"
            } ],
            "disabled" : "false",
            "id" : "AddChildProductFeatureCategory_productFeatureCategoryId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productFeatureCategoryId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddChildProductFeatureCategory",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddChildProductFeatureCategory_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addChildProductFeatureCategory"
      }
]